import { AvatarStyle } from "flavr-common";
export const UNDEFINED_CLIENT_ID = "";
export const UNDEFINED_USER = {
    clientId: UNDEFINED_CLIENT_ID,
    clientIdx: -1,
    avatar: {
        imageUrl: "",
        baseColor: 0,
        style: AvatarStyle.Monitor
    }
};
